module.exports = __webpack_public_path__ + "static/media/Balenciaga-Black-Speed-Knit-Sneakers-Lyst.45243f8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/sneakers/Balenciaga-Black-Speed-Knit-Sneakers-Lyst.png
// module id = 293
// module chunks = 0